import { AxiosInstance } from 'axios';
import { SyncRunFilters, SyncRunResult, SyncRunsResponse } from './admin.types';

export const createAdminApi = (api: AxiosInstance) => ({
  syncBusinessPartners: () =>
    api.post<SyncRunResult>('/v1/business-partners/sync').then((r) => r.data),
  syncEmployees: () =>
    api.post<SyncRunResult>('/v1/employees/sync').then((r) => r.data),
  syncItems: () =>
    api.post<SyncRunResult>('/v1/items/sync').then((r) => r.data),
  syncShippingTypes: () =>
    api.post<SyncRunResult>('/v1/shipping-types/sync').then((r) => r.data),
  syncSapOrders: () =>
    api.post<SyncRunResult>('/v1/sap-orders/sync').then((r) => r.data),
  computeItemKpis: () =>
    api.post<SyncRunResult>('/v1/item-kpis/compute').then((r) => r.data),
  getSyncRuns: (filters?: SyncRunFilters) =>
    api.get<SyncRunsResponse>('/v1/sync-runs', { params: filters }).then((r) => r.data),
  getLatestSyncRuns: () =>
    api.get<SyncRunResult[]>('/v1/sync-runs/latest').then((r) => r.data),
});
